import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faMapMarker,
  faPhone,
  faCoins,
  faExchangeAlt,
  faBroadcastTower,
  faUsers,
  faDatabase,
} from "@fortawesome/free-solid-svg-icons";
import {
  MdSpaceDashboard,
  MdPersonSearch,
  MdAssessment,
  MdManageAccounts,
  MdFileDownload,
  MdWhatshot,
  MdWorkOutline,
  MdOutlineCancel,
  MdContactMail,
  MdSettings,
  MdCancel,
  MdLogout,
} from "react-icons/md";
import { TbSettingsAutomation } from "react-icons/tb";
import { AiOutlineFileExcel } from "react-icons/ai";
import {
  FaWpforms,
  FaPaperPlane,
  FaBolt,
  FaHistory,
  FaUserPlus,
  FaUserCircle,
  FaMoneyCheckAlt,
  FaFileInvoiceDollar,
  FaBug, // Scrapping Errors
  FaEnvelope, // Email Logs
  FaUserCheck, // Payment Customerwise
  FaCalendarAlt, // Payment Monthwise
  FaTimesCircle, // Cancelled Subscriptions
  FaUserClock,
  FaNetworkWired,
  FaChartBar,
} from "react-icons/fa";
import { IoSendOutline } from "react-icons/io5";
import { AiOutlineMail, AiOutlineBell } from "react-icons/ai";

import { NavItem, NavLink, Nav } from "reactstrap";
import classNames from "classnames";
import LocalStorageService from "../utils/localStorageServices";
import "./sidebar.css";
import { Link, useLocation } from "react-router-dom";
import SubMenu from "./SubMenu";
import SOURCES from "../utils/constants";

const localStorageServices = LocalStorageService.getService();

const SideBar = ({ isOpen, toggle, isMobile }) => {
  const location = useLocation();
  const currentUser = localStorageServices.getCurrentUser();
  const userRole = currentUser.user?.userRole
    ? currentUser.user?.userRole
    : currentUser.user?.userType;

  const logOut = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    localStorageServices.clearToken();
    window.location.reload();
  };

  const linkHighlited = (path) => {
    const defaultClasses =
      "!flex items-center relative px-3 py-2 text-gray-900 rounded-lg hover:bg-gray-100 hover:text-primary text-base font-medium gap-2 !w-full";

    if (location.pathname !== path) return defaultClasses;

    return `${defaultClasses} text-primary bg-gray-100`;
  };

  const submenus = [
    [
      {
        title: "Leads Imported",
        target: "/leads-Imported",
        icon: <MdFileDownload />,
      },
      {
        title: "Leads Imported Via (Form)",
        target: "/leads-imported-via-form",
        hidden: userRole !== SOURCES.USER_ROLE_USER,
        icon: <FaWpforms />,
      },
      {
        title: "Hot Leads",
        target: "/hot-leads",
        hidden: userRole !== SOURCES.USER_ROLE_USER,
        icon: <MdWhatshot />,
      },
      {
        title: "Leads Sent",
        target: "/leads-sent",
        hidden: userRole !== SOURCES.USER_ROLE_USER,
        icon: <IoSendOutline />,
      },
      {
        title: "Notifications",
        target: "/notifications",
        icon: <AiOutlineMail />,
      },
      {
        title: "Autoresponse Sent",
        target: "/autoresponse-sent",
        icon: <FaPaperPlane />,
      },
      {
        title: "Activity Log",
        target: "/activity-log",
        icon: <FaHistory />,
      },
      {
        title: "New Lead Alert",
        target: "/new-lead-alert",
        icon: <FaUserPlus />,
      },
    ],

    [
      {
        title: "Payment History",
        target: "payment-history",
      },
      {
        title: "Invoices",
        target: "invoices",
      },
    ],

    [
      {
        title: "Customers",
        target: "customers",
      },
    ],

    [
      {
        title: "Leads Imported",
        target: "/admin/leads-imported",
        icon: <MdFileDownload />,
      },
      {
        title: "Leads Not Sent",
        target: "/admin/leads-not-send",
        icon: <MdOutlineCancel />,
      },
      {
        title: "Scrapping Errors",
        target: "/admin/scrapping-errors",
        icon: <FaBug />,
      },
      {
        title: "Email Logs",
        target: "/admin/email-logs",
        icon: <FaEnvelope />,
      },
      {
        title: "Payment Customerwise",
        target: "/admin/payment-history",
        icon: <FaUserCheck />,
      },
      {
        title: "Payment Monthwise",
        target: "/admin/income-report",
        icon: <FaCalendarAlt />,
      },
      {
        title: "Cancelled Subscriptions",
        target: "/admin/cancelled-subscriptions",
        icon: <FaTimesCircle />,
      },
      {
        title: "Low Activity Users",
        target: "/admin/low-activity-users",
        icon: <FaUserClock />,
      },
      {
        title: "Static Residential Proxies",
        target: "/admin/static-residential-proxies",
        icon: <FaNetworkWired />,
      },
      {
        title: "Webshare Proxy Stats",
        target: "/admin/webshare-proxy-statistics",
        icon: <FaChartBar />,
      },
    ],

    [
      {
        title: "Lead Import Jobs",
        target: "/lead-sources",
        hidden: userRole !== SOURCES.USER_ROLE_USER,
        icon: <MdWorkOutline />,
      },
      {
        title: "Lead Import (CSV)",
        target: "/leads-import-csv",
        hidden: userRole !== SOURCES.USER_ROLE_USER,
        icon: <AiOutlineFileExcel />,
      },
      {
        title: "Contact Request Forms",
        target: "/web-link",
        hidden: userRole !== SOURCES.USER_ROLE_USER,
        icon: <MdContactMail />,
      },
    ],

    [
      {
        title: "Autoresponders",
        target: "/autoresponders",
        icon: <AiOutlineMail />,
      },
      {
        title: "Alerts",
        target: "/alerts",
        icon: <AiOutlineBell />,
        // hidden:
        //   userRole !== SOURCES.USER_ROLE_ADMIN ||
        //   userRole !== SOURCES.USER_ROLE_AFFILIATE,
      },
      {
        title: "Zapier Integration",
        target: "/zapier-configuration",
        icon: <FaBolt />,
        // hidden:
        //   userRole !== SOURCES.USER_ROLE_ADMIN ||
        //   userRole !== SOURCES.USER_ROLE_AFFILIATE,
      },
    ],
    [
      {
        title: "Profile",
        target: "/profile",
        icon: <FaUserCircle />,
      },
      {
        title: "Settings",
        target: "/settings",
        icon: <MdSettings />,
      },
      {
        title: "Payment History",
        target: "/payment-history",
        icon: <FaMoneyCheckAlt />,
        hidden:
          userRole === SOURCES.USER_ROLE_ADMIN ||
          userRole === SOURCES.USER_ROLE_AFFILIATE,
      },
      {
        title: "Invoices",
        target: "/invoices",
        icon: <FaFileInvoiceDollar />,
        hidden:
          userRole === SOURCES.USER_ROLE_ADMIN ||
          userRole === SOURCES.USER_ROLE_AFFILIATE,
      },
      // {
      //   title: "Cancel Subscription",
      //   target: "/cancel-subscription",
      //   icon: <MdCancel />,
      // },
      {
        title: "Sign Out",
        // target: Link,
        onClick: () => logOut(),
        icon: <MdLogout />,
      },
    ],
  ];


  const ActiveLinkHighlight = ({ path }) => {
    const isActive = location.pathname === path;

    return (
      <div
        className={`absolute top-1/2 -translate-y-1/2 right-2 w-1 h-5 bg-[#2dbdf2] rounded-md ${isActive ? "" : "hidden"
          }`}
      />
    );
  };

  return (
    <div className={classNames("sidebar overflow-y-auto lg:!min-w-[280px] !min-w-full", { "is-open": isOpen, "mobile-sidebar": isMobile })}>
      <div className="sidebar-header">
        {!isMobile && (
          <span color="info" onClick={toggle}>
            &times;
          </span>
        )}
        <h3>
          <NavLink
            tag={Link}
            to={
              userRole === SOURCES.USER_ROLE_AFFILIATE
                ? "/dashboard-affiliate"
                : "/dashboard"
            }
          >
            <img src="/logo.png" alt="Leads Import" width="120px" />
          </NavLink>
        </h3>
      </div>
      <div className="side-menu !overflow-y-auto w-full">
        <Nav vertical className="list-unstyled pb-3 space-y-2 !overflow-y-auto px-2">
          <NavItem>
            {userRole !== SOURCES.USER_ROLE_AFFILIATE ? (
              <NavLink
                tag={Link}
                to={"/dashboard"}
                onClick={toggle}
                className={linkHighlited("/dashboard")}
              >
                <span>
                  {" "}
                  <MdSpaceDashboard />
                </span>
                <span>Dashboard</span>
                <ActiveLinkHighlight path="/dashboard" />
              </NavLink>
            ) : (
              <>
                <NavLink
                  tag={Link}
                  to={"/dashboard-affiliate"}
                  onClick={toggle}
                  className={linkHighlited("/dashboard-affiliate")}
                >
                  <span>
                    {" "}
                    <MdSpaceDashboard />
                  </span>
                  <span>Dashboard</span>
                  <ActiveLinkHighlight path="/dashboard-affiliate" />
                </NavLink>
                <SubMenu
                  title="Reports"
                  icon={<MdAssessment />}
                  items={submenus[2]}
                  toggle={toggle}
                />
              </>
            )}
          </NavItem>
          {userRole !== SOURCES.USER_ROLE_ADMIN &&
            userRole !== SOURCES.USER_ROLE_AFFILIATE ? (
            <>
              <SubMenu
                title="Lead Management"
                icon={<MdPersonSearch size={20} />}
                items={submenus[4]}
                toggle={toggle}
              />
              {/* <NavItem>
                <NavLink
                  tag={Link}
                  to={"/autoresponders"}
                  onClick={toggle}
                  className={linkHighlited("/autoresponders")}
                >
                  <FontAwesomeIcon icon={faReply} className="mr-2" />
                  Autoresponders
                </NavLink>
              </NavItem>

              <NavItem>
                <NavLink
                  tag={Link}
                  to={"/alerts"}
                  onClick={toggle}
                  className={linkHighlited("/alerts")}
                >
                  <FontAwesomeIcon icon={faBell} className="mr-2" />
                  Alerts
                </NavLink>
              </NavItem>

              <NavItem>
                <NavLink
                  tag={Link}
                  to={"/zapier-configuration"}
                  onClick={toggle}
                  className={linkHighlited("/zapier-configuration")}
                >
                  <FontAwesomeIcon icon={faWrench} className="mr-2" />
                  Zapier Configration
                </NavLink>
              </NavItem> */}

              <SubMenu
                title="Automations"
                icon={<TbSettingsAutomation />}
                items={submenus[5]}
                toggle={toggle}
              />

              <NavItem>
                <NavLink
                  tag={Link}
                  to={"/destinations"}
                  onClick={toggle}
                  className={linkHighlited("/destinations")}
                >
                  <FontAwesomeIcon icon={faMapMarker} className="mr-2" />
                  <span>Destinations</span>
                  <ActiveLinkHighlight path="/destinations" />
                </NavLink>
              </NavItem>
              {/* 
              <NavItem>
                <NavLink
                  tag={Link}
                  to={"/lead-sources"}
                  onClick={toggle}
                  className={linkHighlited("/lead-sources")}
                >
                  <FontAwesomeIcon icon={faFileImport} className="mr-2" />
                  Lead Import Jobs
                </NavLink>
              </NavItem>

              <NavItem>
                <NavLink
                  tag={Link}
                  to={"/leads-import-csv"}
                  onClick={toggle}
                  className={linkHighlited("/leads-import-csv")}
                >
                  <FontAwesomeIcon icon={faFileImport} className="mr-2" />
                  Lead Import (CSV)
                </NavLink>
              </NavItem> */}

              {/* <NavItem>
                <NavLink
                  tag={Link}
                  to={"/web-link"}
                  onClick={toggle}
                  className={linkHighlited("/web-link")}
                >
                  <FontAwesomeIcon icon={faLink} className="mr-2" />
                  Contact Request Forms
                </NavLink>
              </NavItem> */}

              <SubMenu
                title="Reports"
                icon={<MdAssessment />}
                items={submenus[0]}
                toggle={toggle}
              />
              {/* <SubMenu
                title="Accounting"
                icon={<MdAccountBalance />}
                items={submenus[1]}
                toggle={toggle}
              /> */}

              {/* <NavItem>
                <NavLink
                  tag={Link}
                  to={"/profile"}
                  onClick={toggle}
                  className={linkHighlited("/profile")}
                >
                  <FontAwesomeIcon icon={faUser} className="mr-2" />
                  Profile
                </NavLink>
              </NavItem> */}
              {/* 
              <NavItem>
                <NavLink
                  tag={Link}
                  to={"/settings"}
                  onClick={toggle}
                  className={linkHighlited("/settings")}
                >
                  <FontAwesomeIcon icon={faCogs} className="mr-2" />
                  Settings
                </NavLink>
              </NavItem> */}

              {/* <NavItem>
                <NavLink
                  tag={Link}
                  to={"/cancel-subscription"}
                  onClick={toggle}
                  className={linkHighlited("/cancel-subscription")}
                >
                  <FontAwesomeIcon icon={faTimes} className="mr-2" />
                  Cancel Subscription
                </NavLink>
              </NavItem> */}

              <NavItem>
                <NavLink
                  tag={Link}
                  to=""
                  onClick={() =>
                    (window.location.href = "mailto:support@leadsimport.com")
                  }
                  className={linkHighlited("")}
                >
                  <FontAwesomeIcon icon={faPhone} className="mr-2" />
                  <span>Help/Support</span>
                  <ActiveLinkHighlight path="/destinations" />
                </NavLink>
              </NavItem>
            </>
          ) : (
            <>
              {userRole === SOURCES.USER_ROLE_AFFILIATE ? (
                <div></div>
              ) : (
                <>
                  <NavItem>
                    <NavLink
                      tag={Link}
                      to={"/admin/users"}
                      onClick={toggle}
                      className={linkHighlited("/admin/users")}
                    >
                      <FontAwesomeIcon icon={faUser} className="mr-2" />
                      <span>Users</span>
                      <ActiveLinkHighlight path="/admin/users" />
                    </NavLink>
                  </NavItem>
                  {/* <SubMenu
                    title="Lead Management"
                    icon={<MdPersonSearch />}
                    items={submenus[4]}
                    toggle={toggle}
                  /> */}
                  {/* my code */}
                  {/* <NavItem>
                    <NavLink tag={Link} to={"/admin/testaccounts"} onClick={toggle} className={linkHighlited("/admin/testaccounts")}>
                      <FontAwesomeIcon icon={faUser} className="mr-2" />
                      Test Accounts
                    </NavLink>
                  </NavItem> */}
                  {/* my code */}

                  {/* <NavItem>
                    <NavLink tag={Link} to={"/admin/leadsImported"} onClick={toggle} className={linkHighlited("/admin/leadsImported")}>
                      <FontAwesomeIcon icon={faFileImport} className="mr-2" />
                      Leads Imported
                    </NavLink>
                  </NavItem> */}

                  <NavItem>
                    <NavLink
                      tag={Link}
                      to={"/admin/coupons"}
                      onClick={toggle}
                      className={linkHighlited("/admin/coupons")}
                    >
                      <FontAwesomeIcon icon={faCoins} className="mr-2" />
                      <span>Coupons</span>
                      <ActiveLinkHighlight path="/admin/coupons" />
                    </NavLink>
                  </NavItem>

                  <NavItem>
                    <NavLink
                      tag={Link}
                      to={"/admin/affiliate-partners"}
                      onClick={toggle}
                      className={linkHighlited("/admin/affiliate-partners")}
                    >
                      <FontAwesomeIcon
                        icon={faBroadcastTower}
                        className="mr-2"
                      />
                      <span>Affiliates / Partners</span>
                      <ActiveLinkHighlight path="/admin/affiliate-partners" />
                    </NavLink>
                  </NavItem>

                  <NavItem>
                    <NavLink
                      tag={Link}
                      to={"/admin/zapier-accounts"}
                      onClick={toggle}
                      className={linkHighlited("/admin/zapier-accounts")}
                    >
                      <FontAwesomeIcon icon={faUsers} className="mr-2" />
                      <span>Zapier Accounts</span>
                      <ActiveLinkHighlight path="/admin/zapier-accounts" />
                    </NavLink>
                  </NavItem>

                  <SubMenu
                    title="Reports"
                    icon={<MdAssessment />}
                    items={submenus[3]}
                    toggle={toggle}
                  />

                  {/* <NavItem>
                    <NavLink tag={Link} to={"/admin/scrappingerrors"} onClick={toggle} className={linkHighlited("/admin/scrappingerrors")}>
                      <FontAwesomeIcon icon={faBug} className="mr-3" />
                      Scrapping Errors
                    </NavLink>
                  </NavItem> */}

                  {/* <NavItem>
                    <NavLink tag={Link} to={"/admin/emaillogs"} onClick={toggle} className={linkHighlited("/admin/emaillogs")}>
                      <FontAwesomeIcon icon={faEnvelope} className="mr-3" />
                      Email Logs
                    </NavLink>
                  </NavItem> */}

                  {/* <NavItem>
                    <NavLink tag={Link} to={"/admin/paymenthistory"} onClick={toggle} className={linkHighlited("/admin/paymenthistory")}>
                      <FontAwesomeIcon icon={faHistory} className="mr-3" />
                      Payment History
                    </NavLink>
                  </NavItem> */}

                  {/* <NavItem>
                    <NavLink tag={Link} to={"/admin/cancelled/subscriptions"} onClick={toggle} className={linkHighlited("/admin/cancelled/subscriptions")}>
                      <FontAwesomeIcon icon={faTimes} className="mr-3" />
                      Cancelled Subscriptions
                    </NavLink>
                  </NavItem> */}

                  <NavItem>
                    <NavLink
                      tag={Link}
                      to={"/admin/change-user-email"}
                      onClick={toggle}
                      className={linkHighlited("/admin/change-user-email")}
                    >
                      <FontAwesomeIcon icon={faExchangeAlt} className="mr-3" />
                      <span>Change User Email</span>
                      <ActiveLinkHighlight path="/admin/change-user-email" />
                    </NavLink>
                  </NavItem>

                  <NavItem>
                    <NavLink
                      tag={Link}
                      to={"/admin/database-backup"}
                      onClick={toggle}
                      className={linkHighlited("/admin/database-backup")}
                    >
                      <FontAwesomeIcon icon={faDatabase} className="mr-2" />
                      <span>Database Backup</span>
                      <ActiveLinkHighlight path="/admin/database-backup" />
                    </NavLink>
                  </NavItem>
                </>
              )}
            </>
          )}

          {userRole !== SOURCES.USER_ROLE_AFFILIATE && (
            <SubMenu
              title={`${userRole !== SOURCES.USER_ROLE_ADMIN ? "Account & Billing" : "Account"}`}
              icon={<MdManageAccounts />}
              items={submenus[6]}
              toggle={toggle}
            />
          )}
          {/* <NavItem>
            <NavLink tag={Link} onClick={logOut}> 
              <FontAwesomeIcon icon={faSignOutAlt} className="mr-2" />
              Sign Out
            </NavLink>
          </NavItem> */}
        </Nav>
      </div>
    </div>
  );
};

export default SideBar;
